import React from 'react';

const KrakAppIcon = () => (
    <svg viewBox="0 0 28 28">
        <rect width="28" height="28" rx="2" fill="#FF3D38" />
        <path
            d="M21 11.7578V11.6591C21 7.82756 17.8399 4.70703 13.9597 4.70703C10.0596 4.70703 6.91943 7.82756 6.91943 11.6591V11.7578L6.91943 15.8461H11.5196L6.91943 18.9667V23.2129L7.21945 23.0154L13.8997 18.5914H13.9797L20.7 23.0154L21 23.2129V21.0404V18.9667L16.3398 15.8461H21V12.5873V11.7578Z"
            fill="white"
        />
    </svg>
);

export default KrakAppIcon;
